// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { InputTextValidatorService } from '../services/input-text-validator.service';

@Directive({
    selector: '[appInputValidator]'
})
export class InputValidatorDirective {

    constructor(
        private inputTextValidatorService: InputTextValidatorService,
        private elementRef: ElementRef) {
    }

    @HostListener('keypress', ['$event'])
     keyEvent(event: KeyboardEvent) {
        const keyCode = event.keyCode;
        const newKeyAdded = event.key || String.fromCharCode(keyCode);
        const previousValue = this.elementRef.nativeElement.value;
        const rawValue = previousValue.concat(newKeyAdded);

        if (!this.isValidInput(rawValue)) {
            return false;
        }
    }

    isValidInput(rawValue: string): boolean {
        return this.inputTextValidatorService.inputTextValidator.test(rawValue);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/input-validator.directive.ts